"use client";
import { SOCIAL_ICONS } from "../icons";
import type { HTMLAttributes, SVGAttributes } from "react";

type IconProps = { name?: string } & Omit<HTMLAttributes<HTMLElement>, "children">;

/** Renders a material symbol name or "social:<name>" SVG icon. */
export function Icon({ name, className, ...elementProps }: IconProps) {
  if (!name) return null;
  if (name.startsWith("social:")) {
    const d = SOCIAL_ICONS[name.slice(7)];
    if (!d) return null;
    return (
      <svg {...elementProps as SVGAttributes<SVGSVGElement>} className={`cms-icon ${className || ""}`} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d={d} />
      </svg>
    );
  }
  return (
    <span {...elementProps} className={`material-symbols-outlined cms-icon ${className || ""}`} aria-hidden="true">
      {name}
    </span>
  );
}
